import React from "react";
import {Button, Form, Input} from "antd";


export default function () {
    const [form] = Form.useForm();
    const onFinish = () => {
    }
    return (
        <Form
            form={form}
            name="material_search"
            layout="inline"
            onFinish={onFinish}

        >
            <Form.Item
                name="materialCode"
                label="运输通知单号"
            >
                <Input placeholder="运输通知单号"/>
            </Form.Item>
            <Form.Item
                name="materialName"
                label="采购订单号"
            >
                <Input placeholder="采购订单号"/>
            </Form.Item>
            <Form.Item
                name="materialCode"
                label="运费承担方"
            >
                <Input placeholder="运费承担方"/>
            </Form.Item>
            <Form.Item
                name="materialName"
                label="订单类型"
            >
                <Input placeholder="订单类型"/>
            </Form.Item>
            <Form.Item
                name="materialName"
                label="状态"
            >
                <Input placeholder="状态"/>
            </Form.Item>


            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="submit"
                            className="margin-left-8"
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}